// src/components/customers/tabs/tabs-RewardPoints.jsx
import React from "react";
export default function RewardPointsTab() {
  return <div className="oc-empty">No reward points</div>;
}

